<script>
    import { spring } from "svelte/motion";
    import { pannable } from "./pan";

    const imageScale = spring(1);
    const coords = spring({ x: 0, y: 0 });

    export let url;
    export let alt;

  let x;
  let y;

  function handler(e) {
    imageScale.set(e.detail.scale, { hard: !e.detail.spring });

    x = e.detail.panX;
    y = e.detail.panY;

    coords.set(
        {
            x: x,
            y: y,
        },
        { hard: !e.detail.spring }
    );
  }
  function handlerPan(e) {
    x = e.detail.panX;
    y = e.detail.panY;

    coords.set(
        {
            x: x,
            y: y,
        },
        { hard: !e.detail.spring }
    );
  }

  function handleZoom (e) {
    imageScale.set(e.detail.scale, { hard: !e.detail.spring });

  }

</script>


<img
    {alt}
    src={url}
    class="w-full h-full object-center object-contain ease-linear"
    
    style="transform: scale({$imageScale}) translate({$coords.x}px,{$coords.y}px)"

    use:pannable
    on:panmove={handlerPan}
    on:zoomchanged={handleZoom}
    {...$$props}
/>
